function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import CButtonClose from '../button/CButtonClose'; //component - CoreUI / CSidebarClose

var CSidebarClose = function CSidebarClose(props) {
  return /*#__PURE__*/React.createElement(CButtonClose, _extends({}, props, {
    buttonClass: 'c-sidebar-close'
  }), /*#__PURE__*/React.createElement("svg", {
    className: "c-icon",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, "x"), /*#__PURE__*/React.createElement("path", {
    d: "M20.030 5.030l-1.061-1.061-6.97 6.97-6.97-6.97-1.061 1.061 6.97 6.97-6.97 6.97 1.061 1.061 6.97-6.97 6.97 6.97 1.061-1.061-6.97-6.97 6.97-6.97z"
  })));
};

export default CSidebarClose;